import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Spacer,
  useToast,
} from '@chakra-ui/react';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useNavigate } from 'react-router-dom';
import { useMutation } from 'urql';
import { DuplicateProjectDocument, Project } from '../../gql/graphql';

type CloneProjectTabProps = {
  project: Pick<Project, 'id'>;
  closeModal: () => void;
};

type FormValues = {
  projectName: string;
};

export default function CloneProjectTab({
  project,
  closeModal,
}: CloneProjectTabProps): React.ReactElement {
  const { t } = useTranslation('company');
  const toast = useToast();

  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<FormValues>({ defaultValues: { projectName: '' } });

  const [, cloneProject] = useMutation(DuplicateProjectDocument);
  const navigate = useNavigate();

  const onSubmit = handleSubmit(async ({ projectName }) => {
    const result = await cloneProject({
      input: {
        projectId: project.id,
        newProjectName: projectName,
      },
    });
    if (result.error) {
      toast({
        title: t('project-settings.clone.error.clone'),
        status: 'error',
      });
    } else {
      toast({
        title: t('project-settings.clone.success.clone'),
        status: 'success',
      });
      navigate(
        `/project/${result.data?.duplicateProject?.project?.id}/takeoff`
      );
      closeModal();
    }
  });

  return (
    <>
      <form onSubmit={onSubmit}>
        <FormControl isRequired>
          <FormLabel>{t('project-settings.clone.project-name')}</FormLabel>
          <Input
            type="text"
            {...register('projectName')}
            placeholder={t('project-settings.clone.project-name')}
          ></Input>
        </FormControl>
        <HStack>
          <Spacer />
          <Button
            variant={'outline'}
            type="submit"
            alignSelf={'end'}
            isLoading={isSubmitting}
            mt={2}
          >
            {t('project-settings.clone.clone-project')}
          </Button>
        </HStack>
      </form>
    </>
  );
}
